import { IStudent } from 'types'

import { baseApi } from './baseApi'

export const programsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_studentEvidence: builder.query<IStudent, {student_id: string, subject_id: string}>({
      query: ({student_id, subject_id}) => {
        return {
          url: `/students/evidence/${student_id}/${subject_id}/`,
        }
      },
      providesTags: ['program'],
    }),
    POST_resetStudentProgram: builder.mutation<any, {student_id: string, subject_id: string}>({
      query: ({student_id, subject_id}) => ({
        url: `/students/program/${student_id}/${subject_id}/reset/`,
        method: 'POST',
      }),
      invalidatesTags: ['program'],
    }),
    PATCH_studentProgram: builder.mutation<any, {student_id: string, subject_id: string, body: any}>({
      query: ({student_id, subject_id, body}) => ({
        url: `/students/program/${student_id}/${subject_id}/save/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['program'],
    }),
  }),
})

export const {
  useGET_studentEvidenceQuery,
  useLazyGET_studentEvidenceQuery,
  usePOST_resetStudentProgramMutation,
  usePATCH_studentProgramMutation,
} = programsAPI
